import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M21.1 8.016c-.5-.587-1.2-1.075-2-1.173H14V3.91C14 1.76 12.2 0 10 0c-.4 0-.8.195-.9.586L5.4 8.798H3c-1.7 0-3 1.27-3 2.933v6.843c0 1.662 1.3 2.933 3 2.933h14.3c1.5 0 2.7-1.076 3-2.445l1.4-8.798c.1-.782-.1-1.564-.6-2.248M5 19.551H3c-.6 0-1-.39-1-.977v-6.843c0-.587.4-.978 1-.978h2zm13.3-.782c-.1.49-.5.782-1 .782H7v-9.58l3.6-7.918c.8.293 1.4.977 1.4 1.857v3.91c0 .587.4.978 1 .978h5.9c.3 0 .5.195.7.391.2.195.2.489.2.684z"
    }, null, -1)
  ]))]))
}
export default { render: render }